import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsps = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_68_10184)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				rx: 16,
				fill: "#333366"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.7984 30.5146L35.3584 3.36914H-2.87267L-8.57056 30.5146H29.7984Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-3.05648 3.49551C-3.05648 3.49551 19.6662 8.15952 20.1142 8.23993C25.3297 9.15895 25.1688 10.1699 25.1688 10.1699C28.8219 10.1469 29.2814 10.2962 29.9133 10.8362C31.8317 12.4444 28.7071 17.1774 28.7071 17.1774C28.259 17.5105 -5.54932 30.5606 -5.54932 30.5606H29.8214L35.5997 3.36914H-3.05648V3.49551Z",
				fill: "#333366"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.3998 12.3066C22.8828 12.5593 21.5503 12.6972 20.9184 12.7546C20.3096 12.8006 20.1488 12.8695 20.1373 13.0993C20.1258 13.306 20.2292 13.4209 21.0908 13.4209C23.0781 13.4209 26.6508 12.6742 27.7306 13.0188C28.305 13.2026 27.8455 14.2136 27.3745 15.5461C27.1907 16.0631 27.5468 16.0286 27.7536 15.7989C27.9604 15.5691 28.8909 13.8804 28.9943 13.0073C29.1322 11.7782 28.0868 11.5944 26.6278 11.5944H24.3188C24.1924 11.5944 24.1005 11.6748 23.9512 11.8701C23.8363 12.0309 23.7329 12.1343 23.3998 12.3066Z",
				fill: "#333366"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-4.36603 9.65294L-8.80029 30.5606C-8.80029 30.5606 4.80116 23.8862 6.45539 23.0361C9.86724 21.29 14.5772 18.9695 18.9311 17.4876C19.7582 17.2004 23.3194 16.109 25.3871 15.7414C26.1913 15.5921 26.5244 15.4657 26.5244 15.3049C26.49 14.8799 25.6858 14.8454 24.3188 14.9143C20.1487 15.1096 12.1648 18.2917 9.86724 19.4979L7.27102 11.4565H23.8593C24.606 9.36575 14.0373 9.66443 13.7156 9.64146H-4.36603V9.65294Z",
				fill: "#333366"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_68_10184",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 16,
			fill: "white"
		})
	}) })]
});
export default SvgUsps;
